import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';

@Component({
	selector: 'snackBar',
	templateUrl: 'snackbar.component.html',
})
export class SnackbarComponent {
	public type: string;
	public content: string;
	public title: string;

	constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
		this.type = 'alert-' + data.type;
		this.content = data.content;
		this.title = data.title;
	}
}
